import { ScaleElement } from '@scale/base-element';

class ProductCard extends ScaleElement {
  #productUrl;

  setup() {
    this.#productUrl = this.getAttribute('data-product-url');
    if (!this.#productUrl) return;

    this.on('click', this.#handleClick);
  }

  #handleClick = (e) => {
    if (e.target.closest('a, button, input, select, textarea, scale-product-card-swatches, scale-quick-add')) return;
    if (e.target.closest('scale-product-card-gallery[data-carousel], scale-product-card-gallery[data-thumbnails]')) return;

    window.location.href = this.#productUrl;
  };
}

if (!customElements.get('scale-product-card')) {
  customElements.define('scale-product-card', ProductCard);
}
